import { TranslationHelper } from "app/helpers/translationHelper";
import { EventIncidentType } from "app/types/eventType";
import { FormattedMessage } from "react-intl";
import "../../BasketballPhase.scss";

export default function BasketballPhaseLive(props: {
  eventIncidents: EventIncidentType[];
  eventPhase: string;
}) {
  const { eventPhase, eventIncidents } = props;

  // Determine the value to display based on eventPhase
  // if NCBAA event (has two halves not 4 quarters)
  // then we display the half values as H1 & H2
  const displayValue =
    eventPhase === "FIRST_HALF"
      ? "events-phase-1H"
      : eventPhase === "SECOND_HALF"
      ? "events-phase-2H"
      : eventPhase === "OVER_TIME"
      ? "events-phase-overtime"
      : eventPhase;

  return (
    <div className="basketball-phase">
      <div className="basketball-phase__info">
        <FormattedMessage
          tagName="span"
          id={TranslationHelper.getTranslationIdForMarket(
            displayValue,
            "",
            "",
            true
          )}
        />
        <div className="eventPhase">{eventIncidents[0]["remainingTime"]}</div>
      </div>
    </div>
  );
}
